<template>
    <v-container>
        <v-layout row wrap pt-2>
            <v-flex lg7 md6>
                <h1 class="mb-2">
                    <router-link 
                        :to="{ 
                            name: 'Electorate',
                            params: { 
                                Electorate: division, 
                                State: state
                            }
                        }">
                        {{ division }}, {{ stateAbbrev }}
                    </router-link>
                </h1>
                <h3 class="blue-grey--text text--darken-1">Federal Election {{ year }}</h3>
            </v-flex>
            <v-flex lg5 md6>
                <division-statistics :division="division" :year="year" :electionId="electionId"></division-statistics>
            </v-flex>        
        </v-layout>
        <br/>    
        <br/>
        <div v-if="showTwoCandidatePreferred">
            <two-candidate-preferred :division="division" :state="state" :year="year" :electionId="electionId"></two-candidate-preferred>
            <br/>
        </div>
        <br/>
        <div>
            <first-preference-count :division="division" :year="year" :state="state" :electionId="electionId"></first-preference-count>
        </div>
        <br/>
        <br/>
        <div v-if="showFirstPreferencesByVoteType">
            <first-preferences-by-vote-type :division="division" :year="year"></first-preferences-by-vote-type>
            <br/>
        </div>
        <br/>
        <div v-if="showTwoCandidatePreferredByVoteType">
            
            <two-candidate-preferred-by-vote-type :division="division" :year="year"></two-candidate-preferred-by-vote-type>
            <br/>
        </div>
        <br/>
        <div v-if="showTwoCandidatePreferredPreferenceFlow">
            <two-candidate-preferred-preference-flow :division="division" :year="year"></two-candidate-preferred-preference-flow>
            <br/>
        </div>
        <br/>
        <div v-if="showFullDistributionOfPreferences">
            <h2>Full distribution of preferences</h2>
            <br/>
            <distribution-of-preferences :division="division" :year="year"></distribution-of-preferences>
            <br/>
        </div>
        <br/>
        <div v-if="showPollingPlaces">
            <polling-places :division="division" :state="state" :year="year"></polling-places>
            <br/>
        </div>
        <br/>
    </v-container>
</template>
<script>
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    import TwoCandidatePreferred from './TwoCandidatePreferred.vue';
    import FirstPreferenceCount from './FirstPreferenceCount.vue';
    import FirstPreferencesByVoteType from './FirstPreferencesByVoteType.vue';
    import TwoCandidatePreferredByVoteType from './TwoCandidatePreferredByVoteType.vue';
    import TwoCandidatePreferredPreferenceFlow from './TwoCandidatePreferredPreferenceFlow.vue';
    import DistributionOfPreferences from './DistributionOfPreferences.vue';
    import PollingPlaces from './PollingPlaces.vue';
    import DivisionStatistics from './DivisionStatistics.vue';    

    const dataCutoff = 2004;

    export default {
        props: ['division', 'year', 'electionId'],
        created() {
            this.initialiseData();
        },
        data: function() {
            return {
                data: null                
            }
        },
        methods: {
            initialiseData: function () {
                const url = `Elections/Division?divisionName=${this.division}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.data = response.data;
                    });
            }
        },
        components: {
            TwoCandidatePreferred,
            FirstPreferenceCount,
            FirstPreferencesByVoteType,
            TwoCandidatePreferredByVoteType,
            TwoCandidatePreferredPreferenceFlow,
            PollingPlaces,
            DivisionStatistics,
            DistributionOfPreferences
        },
        computed: {
            state() {
                return this.data ? this.data.State : '';
            },
            stateAbbrev() {
                return this.data ? this.data.StateAbbrev : '';
            },
            showPollingPlaces() {
                return this.year >= dataCutoff;
            },
            showFirstPreferencesByVoteType() {
                return this.year >= dataCutoff;
            },
            showTwoCandidatePreferredByVoteType() {
                return this.year >= dataCutoff;
            },
            showTwoCandidatePreferredPreferenceFlow() {
                return this.year >= dataCutoff;
            },
            showFullDistributionOfPreferences() {
                return this.year >= dataCutoff;
            },
            showTwoCandidatePreferred() {
                return this.year >= 1919;
            }
        }
    }
</script>
<style>
    h1 a {
        text-decoration: none;
    }
</style>